import Vue from "vue";
import router from "@/router";
import VueGtag from "vue-gtag";

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-GH8JT8L8LP"
    }
  },
  router
);

export default VueGtag;
